module.exports = "/images/eula.svg?55d4f08065514df096cc89ceec8bae10";